import { all, fork } from 'redux-saga/effects';
import info from './info';

export default function* dashboard() {
  yield all([fork(info)]);
}
